import pdfjsExpress from "@pdftron/pdfjs-express-viewer"

window.PdfCore = window.PdfCore || {};
window.PdfUI = window.PdfUI || {};

window.PDFViewerApplication = {
    initUI: function (dotNetObjRef, culture, license) {
        const viewerElement = document.getElementById("viewer");
        pdfjsExpress({
            path: "dist/lib",
            licenseKey: license,
            isReadOnly: true,
            enableAnnotations: false,
            enableFilePicker: false,
            enableMeasurement: false,
            enableRedaction: false,
            enablePrint: false,
            enableDownload: false,
            extension: "pdf"
        }, viewerElement)
            .then((instance) => {
                const { Core, UI } = instance;

                window.PdfCore = Core;
                window.PdfUI = UI;
                
                PdfUI.disableFeatures([instance.UI.Feature.Print]);
                PdfUI.disableFeatures([instance.UI.Feature.Download]);
                PdfUI.disableFeatures([instance.UI.Feature.FilePicker]);

                const current = culture?.substring(0, 2);

                if (culture && current) {
                    instance.UI.setLanguage(current);
                }

                const localTheme = localStorage.getItem("theme");

                if (localTheme && localTheme.indexOf("dark") > 0) {
                    instance.UI.setTheme(instance.UI.Theme.DARK);
                }
                
                // adding an event listener for when a document is loaded
                PdfCore.documentViewer.addEventListener("documentLoaded",
                    () => {
                        dotNetObjRef.invokeMethodAsync("InvokeStopLoading");
                    });

                // adds a button to the header that on click sets the page to the next page
                PdfUI.setHeaderItems(header => {
                    header.push({
                        type: "actionButton",
                        img: "../../assets/images/caret-right-fill.svg",
                        onClick: () => {
                            const currentPage = PdfCore.documentViewer.getCurrentPage();
                            const totalPages = PdfCore.documentViewer.getPageCount();
                            const atLastPage = currentPage === totalPages;

                            if (atLastPage) {
                                PdfCore.documentViewer.setCurrentPage(1);
                            } else {
                                PdfCore.documentViewer.setCurrentPage(currentPage + 1);
                            }
                        }
                    });
                });

                dotNetObjRef.invokeMethodAsync("InvokeLoadJs");
            });
    },
    loadPdf: async function (base64String, pdfname) {
        const blob = base64ToBlob(base64String);
        const doc = await PdfCore.createDocument(blob, { extension: "pdf" });
        PdfUI?.loadDocument(doc, { filename: pdfname });
    }
};

function base64ToBlob(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: "application/pdf" });
};